import React from "react";
import {Col, Row} from "reactstrap";
import {ArrowDownCircle, ArrowUpCircle, Activity, Clock} from "react-feather";
import WidgetInformationWithIcon from "../../../../CommonComponents/Dashboard/DashboardWidget";
import type {Wallet} from "../../Types/WalletTypes";

interface WalletDashboardProps {
    wallet: Wallet;
}

const WalletDashboard = ({wallet}: WalletDashboardProps) => {
    const inflowTransactions = wallet.statistics?.inflow_transactions ?? 0;
    const outflowTransactions = wallet.statistics?.outflow_transactions ?? 0;
    const totalTransactions = wallet.statistics?.total_transactions ?? 0;
    const pendingConfirmations = wallet.statistics?.pending_confirmations ?? 0;

    return (
        <div>
            <Row>
                <Col xxl='auto' xl='3' sm='6' className='box-col-6'>
                    <Row>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Inflow Transactions',
                                gros: 5,
                                total: inflowTransactions,
                                color: 'success',
                                icon: <ArrowDownCircle size={16} color={'green'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Outflow Transactions',
                                gros: 50,
                                total: outflowTransactions,
                                color: 'secondary',
                                icon: <ArrowUpCircle size={16} color={'purple'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Total Transactions',
                                gros: 20,
                                total: totalTransactions,
                                color: 'primary',
                                icon: <Activity size={16} color={'orange'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Pending Confirmations',
                                gros: 10,
                                total: pendingConfirmations,
                                color: 'default',
                                icon: <Clock size={16} color={'blue'}/>,
                            }}/>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default WalletDashboard;

